import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

import { closeCurrentYear } from 'RestAPIs/admin';

import showError from 'components/shared/showError';

export const useCloseYear = () => {
  return useMutation(closeCurrentYear, {
    onError: (err) => showError(err as AxiosError)
  });
};
